// Módulo Empreendimentos (vertical imobiliária, fase 1): lista de
// empreendimentos + espelho de vendas de um empreendimento. Backend em
// /api/v1/accounts/:account_id/empreendimentos/... (ver api/empreendimentos.js).
import { frontendURL } from '../../../helper/URLHelper';

const DevelopmentsIndex = () => import('./DevelopmentsIndex.vue');
const DevelopmentShow = () => import('./DevelopmentShow.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/empreendimentos'),
    name: 'empreendimentos_developments',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: DevelopmentsIndex,
  },
  {
    path: frontendURL('accounts/:accountId/empreendimentos/:developmentId'),
    name: 'empreendimentos_development',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: DevelopmentShow,
    props: route => ({ developmentId: Number(route.params.developmentId) }),
  },
];
